import { IPatientInfo } from 'apis/admin/type';
import { SurveyFormProps } from 'components/MuiDialog/SurveyForm';
import {
  initialECardex,
  initialTakingOver,
  initialOutHospitalSurvey,
  initialHospitalizationSurvey,
  initialMedicationSurvey,
  initialRadiology,
  initialPathology,
  initialBedScore,
  initialFall,
  initialPediatric_fall,
  initialGCS,
  initialPediatric_GCS,
  initialFourScore,
  initialSafety,
  initialNeeds,
  initialClinicalObservation,
  initialGlucose,
  initialNRS,
  initialFLACC,
  initialCNPS,
  initialFFI,
  initialKOOS,
  initialLEFS,
  initialSTarTBack,
  initialNDI,
  initialMentalNursing,
  initialBDI,
  initialBAI,
  initialMMSE,
  initialOperation,
  initialAnesthesia,
  initialTransfusion,
  initialDialysis,
  initialEmergency,
  initialChildbirth,
  initialHomeCare,
  initialDietNutrition,
  initialFallPrevention,
  initialTransfusionAgree,
  initialColonoscopy,
  initialTransfusionAgreement,
  initialNonSalary,
  initialAdmissionCheckList,
  initialDNR,
  initialCoreNursingSkillVideo,
  initialIntakeOutput,
  initialClinicalObservationICU,
  initialIntubation,
  initialCPR,
  initialHospitalConfirm,
  initialCRRT,
  initialIntubationAgree,
  initialCentralVenous,
  initialSuppressor,
  initialSBAR,
  initialSBAR2,
  initialSBAR3,
} from './initialStates';

export enum MENU {
  E_CARDEX = 'e-Кардех',
  SBAR1 = 'SBAR 1',
  SBAR2 = 'SBAR 2',
  SBAR3 = 'SBAR 3',
  TAKING_OVER = 'Сувилагч шилжүүлэх',
  HOSPITALIZATION = 'Хэвтэн эмчлүүлэгчийн бүртгэл',
  OUT_HOSPITAL = 'Гаралтын бүртгэл',
  PRESCRIPTION = 'Өвчтөний байдал, жор',
  NURSE = 'Сувилахуйн тэмдэглэл',
  MEDICATION = 'Эмийн тэмдэглэл',
  RADIOLOGY = 'Рентген бичлэг',
  PATHOLOGY = 'Клиникийн эмгэг судлал',
  CLINICAL_OBSERVATION = 'Амин чухал шинж тэмдэгийн бүртгэл',
  CLINICAL_OBSERVATION_ICU = 'Клиникийн ажиглалтын бүртгэл (ЭМТ)',
  IORECORD = 'I/O',
  GLUCOSE = 'Цусан дахь сахар хэмжих бүртгэл',
  BEDSORES = 'Брадены масштаб',
  NEEDS = 'Хэрэгцээний үнэлгээ',
  FALL = 'Морсийн уналтын масштаб',
  FALLSCALE = 'Хампти Дампти уналтын масштаб',
  GCS = 'GCS',
  Pediatric_GCS = 'Хүүхдийн GCS',
  FourScore = 'Дөрвөн оноо (FOUR)',
  SAFETY = 'Өвчтөний аюулгүй байдлын тайлан',
  PAIN = 'Өвдөлтийн үнэлгээ',
  NRS = 'NRS',
  FLACC = 'FLACC Scale',
  CNPS = 'CNPS',
  FFI = 'FFI',
  KOOS = 'KOOS',
  LEFS = 'LEFS',
  NDI = 'NDI',
  STarT_BacknScreening = 'Нурууны өвдөлтийн үнэлгээний дэлгэцийн тест',
  MENTAL_NURSING = 'Сэтгэцийн эрүүл мэндийн бүртгэл',
  BDI = 'BDI',
  BAI = 'BAI',
  MMSE = 'MMSE',
  COGNITIVE_FUNCTION = '인지기능검사',
  OPERATION = 'Мэс заслын бүртгэл',
  ANESTHESIA = 'Мэдээ алдуулалтын бүртгэл',
  TRANSFUSION = 'Цус сэлбэлтийн бүртгэл',
  INTUBATION = 'Төгсөлтийн бүртгэл',
  CPR = 'CPR',
  DIALYSIS = 'Диализийн бүртгэл',
  EMERGENCY = 'Яаралтай тусламжийн бүртгэл',
  CHILDBIRTH = 'Төрөхийн бүртгэл',
  HOME_CARE = 'Гэрийн асаргааны бүртгэл',
  DIET_NUTRITION = 'Хоол тэжээлийн бүртгэл',
  AGREEMENT = 'зөвшөөрөл',
  PATIENTSGUIDE = 'Өвчтөний гарын авлага',
  PATIENTCONSENTFORM = 'Өвчтөний зөвшөөрлийн маягт',
  TRANSFUSION_AGREE = 'Цус сэлбэлтийн зөвшөөрөл',
  CONSCIOUS = 'хаантай мэдээ алдуулалтын зөвшөөрөл',
  DNR = 'DNR',
  ADMISSION = 'Эмнэлэгт хэвтэх гэрээ',
  ADMISSIONGUIDE = 'Эмнэлэгт хэвтэх гарын авлага',
  ADMISSION_CHECKLIST = 'Эмнэлэгт хэвтэх шалгах жагсаалт',
  FALL_PREVENTION = 'Уналтаас сэргийлэх',
  CRRT_AGREEMENT = 'CRRT',
  CENTRALVENOUS = 'Төв венийн катетер тавих',
  INTUBATIONAGREEMENT = 'ETI',
  SUPPRESSOR = 'Бие махбодын хязгаарлалт',
  DRUGCALCULATOR = 'Эмийн тун тооцоолуур',
  CORE_NURSING_SKILL_VIDEO = 'Видео байршуулах',
  CORE_NURSING_SKILL_VIDEO_EXEMPLE = 'Screen Settings',
  PATIENT_LABEL_PRINTING = 'Patient Label Printing',
}

export enum RECORD_TYPE {
  NANDA = '0',
  SOAPIE = '1',
  FOCUS_DAR = '2',
  NARRATIVE_RECORD = '3',
  REMARKS = '4',
}

export interface SurveyDialogProps<T>
  extends Omit<SurveyFormProps, 'children'> {
  user_id: number;
  nurseName: string;
  patientInfo: IPatientInfo;
  disabled?: boolean;
  defaultValues: T;
}

export type TECardexDefaultValues = typeof initialECardex;
export type TSBARDefaultValues = typeof initialSBAR;
export type TSBAR2DefaultValues = typeof initialSBAR2;
export type TSBAR3DefaultValues = typeof initialSBAR3;
export type TTakingOverDefaultValues = typeof initialTakingOver;
export type THospitalizationDefaultValues = typeof initialHospitalizationSurvey;
export type TOutHospitalDefaultValues = typeof initialOutHospitalSurvey;
export type TMedicationDefaultValues = typeof initialMedicationSurvey;
export type TRadiologyDefaultValues = typeof initialRadiology;
export type TPathologyDefaultValues = typeof initialPathology;
export type TClinicalObservationDefaultValues =
  typeof initialClinicalObservation;
export type TClinicalObservationICUDefaultValues =
  typeof initialClinicalObservationICU;
export type TGlucoseDefaultValues = typeof initialGlucose;
export type TIntakeOutputDefaultValues = typeof initialIntakeOutput;
export type TBedScoreDefaultValues = typeof initialBedScore;
export type TNeedsDefaultValues = typeof initialNeeds;
export type TFallDefaultValues = typeof initialFall;
export type TPediatric_fallDefaultValues = typeof initialPediatric_fall;
export type TGCSDefaultValues = typeof initialGCS;
export type TPediaTric_GCSDefaultValues = typeof initialPediatric_GCS;
export type TFourScoreDefaultValues = typeof initialFourScore;
export type TSafetyDefaultValues = typeof initialSafety;
export type TNRSDefaultValues = typeof initialNRS;
export type TFLACCDefaultValues = typeof initialFLACC;
export type TCNPSDefaultValues = typeof initialCNPS;
export type TFFIDefaultValues = typeof initialFFI;
export type TKOOSDefaultValues = typeof initialKOOS;
export type TLEFSDefaultValues = typeof initialLEFS;
export type TNDIDefaultValues = typeof initialNDI;
export type TSTarTBackScreeningDefaultValues = typeof initialSTarTBack;
export type TMentalNursingDefaultValues = typeof initialMentalNursing;
export type TBDIDefaultValues = typeof initialBDI;
export type TBAIDefaultValues = typeof initialBAI;
export type TMMSEDefaultValues = typeof initialMMSE;
export type TOperationDefaultValues = typeof initialOperation;
export type TAnesthesiaDefaultValues = typeof initialAnesthesia;
// Patient Guide => 수혈동의서
export type TTransfusionDefaultValues = typeof initialTransfusion;
// Patient Consent Form => 대장내시경으로
export type TColonoscopyDefaultValues = typeof initialColonoscopy;
export type TTransfusionAgreeDefaultValues = typeof initialTransfusionAgree;
// Conscious Sedation => 비급여동의서로
export type TNonSalaryDefaultValues = typeof initialNonSalary;
export type TDNRDefaultValues = typeof initialDNR;
// Admission Agreement=> 입원안내확인서
export type THospitalConfirmDefaultValues = typeof initialHospitalConfirm;
export type TAdmissionCheckListDefaultValues = typeof initialAdmissionCheckList;
export type TFallPreventionDefaultValues = typeof initialFallPrevention;
export type TCRRTDefaultValues = typeof initialCRRT;
export type TCentralVenousDefaultValues = typeof initialCentralVenous;
export type TIntubationAgreeDefaultValues = typeof initialIntubationAgree;
export type TSuppressorDefaultValues = typeof initialSuppressor;

export type TIntubationDefaultValues = typeof initialIntubation;
export type TCPRDefaultValues = typeof initialCPR;
export type TDialysisDefaultValues = typeof initialDialysis;
export type TEmergencyDefaultValues = typeof initialEmergency;
export type TChildbirthDefaultValues = typeof initialChildbirth;
export type THomeCareDefaultValues = typeof initialHomeCare;
export type TDietNutritionDefaultValues = typeof initialDietNutrition;
export type TTransfusionAgreementDefaultValues =
  typeof initialTransfusionAgreement;
export type TCoreNursingSkillVideoDefaultValues =
  typeof initialCoreNursingSkillVideo;
